define.alias("ember-math-helpers/helpers/tanh", "calendar/helpers/tanh");